<p-iconField iconPosition="left">
  <p-inputIcon styleClass="pi pi-search" />
  <input type="text" pInputText placeholder="Search" [value]="data" (input)="valueBack($event)"/>
</p-iconField>
